import React from 'react'
import Introduction from '../Components/Introduction'
import chickeninhouse from '../Assets/logo-chickeninhouse2.webp'
import product from '../Assets/bucket-fried-chicken.webp'
import Services from '../Components/Services'
import CardServices from '../Components/CardServices'
import chickeninhousemedia from '../Assets/mascote2.webp'
import GeographicPresence from '../Components/GeographicPresence'
import CharlesBrox from '../Assets/bronx.mp4'
import cardapio from '../Assets/cardapio.pdf'
import videoSede from '../Assets/sede-ck.webm'

function ChickeninHouse({ id }) {
  const openPDF = () => {
    window.open(cardapio, '_blank', 'noreferrer')
  }

  return (
    <section id={id}>
      <div className="video-background">
        <video autoPlay loop muted className="background-video">
          <source src={videoSede} type="video/webm" />
          Seu navegador não suporta o vídeo.
        </video>
        <div className="content">
          <Introduction
            srcLogo={chickeninhouse}
            altLogo="Chicken in House"
            description={
              <>
                A Chicken In House, fundada em 2015,{' '}
                <span>tem se destacado no setor de alimentação</span> com um
                modelo de franquia inovador e promissor. Especializada em pratos
                à base de frango frito servidos em baldes, a rede atende à
                demanda crescente por refeições rápidas, acessíveis e de
                qualidade, oferecendo produtos diferenciados, como o frango
                recheado. Com exclusividade em receita e corte, a Chicken In
                House conquistou uma posição sólida no mercado brasileiro,
                elevando a experiência gastronômica dos clientes.
              </>
            }
            // backgroundColor="#D41C21"
            color="white"
            img={true}
            srcProduct={product}
            altProduct="Balde de frango da Chicken in House"
          />
        </div>
      </div>

      <div
        id="image-full-chickeninhouse"
        className="section-image-full flex-center padding-50 flex__gap-50"
      >
        <div data-aos="fade-left" className="image">
          <img src={chickeninhousemedia} alt="Chicken In House" />
        </div>
        <div className="wd-400 flex-center flex-column flex__gap-20 flex__align-start">
          <h1 className="title-main text-dark">
            Confira o cardápio da Chicken in House
          </h1>
          <button className="btn-menu" onClick={openPDF}>
            Veja o Nosso Cardápio
          </button>
        </div>
      </div>

      <div className="video-background flex-center height-70vh">
        <video autoPlay loop muted className="background-video">
          <source src={CharlesBrox} type="video/webm" />
          Seu navegador não suporta o vídeo.
        </video>
        <div className="content half-screen">
          <h1 className="title-main">Charles do Bronx</h1>
          <p className="paragraph-default">
            Agora fazendo parte da{' '}
            <span id="color-chickeninhouse">Chicken in House</span>!
          </p>
        </div>
      </div>

      <Services>
        <CardServices
          title="Centro de Distribuição Próprio"
          description="O Centro de Distribuição Próprio é essencial para a logística, garantindo o abastecimento rápido e de qualidade às franquias. Com um sistema eficiente de armazenamento e entrega, mantém a padronização dos produtos e oferece suporte contínuo, maximizando a eficiência operacional."
          backgroundColor="#D41C21"
          colorTitle="white"
          colorContent="white"
          boxShadow="true"
          height="350px"
        />
        <CardServices
          title="Parceria Estratégica com a Neoquímica"
          description="A parceria com a Neoquímica reforça o compromisso da Chicken In House com inovação e crescimento. Essa colaboração fortalece a marca, tornando-a a única franquia de alimentos no estado, ampliando sua visibilidade e presença em eventos de grande porte, além de consolidar sua imagem no setor alimentício."
          backgroundColor="#D41C21"
          colorTitle="white"
          colorContent="white"
          boxShadow="true"
          height="350px"
        />
        <CardServices
          title="Modelo de Negócio Atrativo"
          description="A simplicidade operacional, aliada ao baixo custo inicial de investimento e alta lucratividade, torna a franquia especialmente atraente para investidores, fomentando uma rápida expansão. Suporte ao Franqueado: Por meio do modelo de Master Franqueado, a empresa assegura suporte constante, garantindo o sucesso e a replicabilidade do modelo de negócio em novas unidades."
          backgroundColor="#D41C21"
          colorTitle="white"
          colorContent="white"
          boxShadow="true"
          height="350px"
        />
        <CardServices
          title="Foco no Cliente"
          description="O foco no cliente é uma prioridade, e isso se reflete na oferta de um cardápio diversificado, cuidadosamente elaborado para atender a todos os gostos. A Chicken In House se compromete com a qualidade dos produtos, garantindo que cada prato supere as expectativas dos consumidores. Além disso, a empresa está sempre em sintonia com as preferências por opções mais variadas e saborosas, proporcionando uma experiência gastronômica única."
          backgroundColor="#D41C21"
          colorTitle="white"
          colorContent="white"
          boxShadow="true"
          height="350px"
        />
      </Services>

      <GeographicPresence
        description={
          <>
            A disponibilidade geográfica da Chicken In House permite uma ampla
            cobertura de mercado e a capacidade de se adaptar a diferentes
            demandas regionais. O mercado brasileiro de alimentação rápida está
            em expansão, com uma demanda crescente por opções convenientes e de
            qualidade. Nesse cenário, a Chicken In House se posiciona
            estrategicamente para capitalizar sobre as tendências de mercado,
            graças à sua rápida expansão, eficiência operacional e parcerias.
            Com sede em Alphaville, a rede já conta com 51 unidades montadas e
            27 em processo de preparação, totalizando 78 franquias, presentes em
            11 estados do Brasil. Nesses locais, a marca se adapta às condições
            econômicas regionais, oferecendo produtos acessíveis que atendem à
            demanda por opções de refeição de valor agregado.
          </>
        }
      />
    </section>
  )
}

export default ChickeninHouse
